import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          Sunlight.io certifies servers from Lenovo to run its software-defined infrastructure and
          infrastructure manager, which are designed to bring cloud-like simplicity to deploying and
          running edge applications. “Enterprises are looking for data-center-class high
          availability and usability but something that can run on very small and efficient devices
          outside of the core data center,” Chesterfield says. In other words, businesses need high
          performance computing that’s always available and doesn’t introduce unacceptable lag due
          to round trips to cloud resources. “These devices can’t consume lots of power, they can’t
          output a lot of heat, they have to be passively cooled by the air, and so on.” He says the
          ThinkEdge family of products from Lenovo hits the mark.
        </p>
        <p className="chapter__paragraph">
          Thanks to such advanced-yet-affordable and ruggedized hardware, innovative software from
          companies like Sunlight.io and Pathr.ai, and data from standard security cameras,
          operations managers everywhere can deploy responsive AI. They’re using it to track and
          predict traffic flows, dispatch employees to provide help where and when needed, and
          generally improve the experience of shoppers, travelers, diners, and employees. Edge AI
          makes the necessary high-speed calculations in real-time while preserving privacy; data
          and images never leave the building.
        </p>
      </section>
    </>
  );
}

export default Chapter4;
